import { AUTH_ADDRESS } from "../../constants/api-constants";

const getMobileFromProfile = (data = {}) => {
    const { userProfiles = [] } =  data;
    const mobileObj = userProfiles.find(obj => obj.addressType === AUTH_ADDRESS.PHONE); // look for first instance
    return mobileObj ? mobileObj.address : "";
};

export default getMobileFromProfile;
